module.exports = __webpack_public_path__ + "img/thsr-geo-logo.b5576265.png";